import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketBebasNapzaInterface } from "@/types/suket_bebas_napza";
import SvcSuketBebasNapza from "@/services/SuketBebasNapza";
import { storePasien } from "@/store/modules/pasien";

@Module({ dynamic: true, namespaced: true, store, name: "suket-bebas-napza" })
class SuketBebasNapza extends VuexModule {
  suket: SuketBebasNapzaInterface = null;
  loading = false;

  get pasien(): any {
    return storePasien.identitasPasien;
  }

  @Mutation
  SET_SUKET(suket: SuketBebasNapzaInterface) {
    this.suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async fetchSuketByRegister(): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketBebasNapza.getByRegister(
      this.pasien.register.no
    ).finally(() => {
      this.SET_LOADING(false);
    });

    // const response = suketArray.data.length ? suketArray[0] : null;
    this.SET_SUKET(suketArray.data.length ? suketArray.data[0] : null);
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const suketArray = await SvcSuketBebasNapza.getByRegister(
      noReg
    ).finally(() => {
      this.context.commit('SET_LOADING', false);
    });

    this.SET_SUKET(suketArray.data.length ? suketArray.data[0] : null);
  }
}

export default getModule(SuketBebasNapza);
